import { SvgIcon } from '@mui/material';
import React from 'react';

const MPBricoIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Brico"
        data-name="Brico"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 43 21"
        strokeWidth={0}
        fill="currentColor"
      >
        <title>Brico</title>
        <path
          d="M14.6678 10.3877L14.6493 10.3806V10.3257L14.6638 10.3178C15.2091 10.0171 15.4854 9.52782 15.4854 8.86347C15.4854 8.33419 15.3071 7.90229 14.9392 7.54263C14.5714 7.18297 14.0662 7 13.4382 7H11.1509C10.4626 7 10 7.44447 10 8.10568V12.8558C10 13.5116 10.4626 13.9513 11.1509 13.9513H13.4189C14.8123 13.9513 15.6781 13.1841 15.6781 11.9488C15.6781 11.1958 15.3095 10.6272 14.6678 10.3877ZM11.636 8.48183H13.1161C13.6101 8.48183 13.8598 8.71034 13.8598 9.16031C13.8598 9.57886 13.5884 9.81916 13.1161 9.81916H11.636V8.48183ZM13.247 12.4789H11.636V11.034H13.2262C13.7602 11.034 14.0309 11.2759 14.0309 11.7517C14.0317 12.2339 13.7675 12.4789 13.247 12.4789Z"
          fill="#FFDC00"
        />
        <path
          d="M19.0481 8.5996C18.7541 8.52029 18.4248 8.48181 18.0425 8.48181C16.8764 8.48181 16.2074 9.11396 16.2074 10.2165V13.2069C16.2074 13.6372 16.5792 14.0008 17.0194 14.0008C17.482 14.0008 17.8313 13.6592 17.8313 13.2069V10.5628C17.8313 10.1223 18.0723 10.0304 18.2755 10.0304C18.4015 10.0304 18.526 10.043 18.6658 10.0704C18.8111 10.0987 18.9131 10.1097 18.9437 10.1097C19.4119 10.1097 19.6649 9.71627 19.6649 9.34562C19.6649 8.94984 19.4633 8.70562 19.0481 8.5996Z"
          fill="#FFDC00"
        />
        <path
          d="M20.888 8.61612C20.4254 8.61612 20.0897 8.95693 20.0897 9.42574V13.1904C20.0897 13.6294 20.4551 14 20.888 14C21.341 14 21.696 13.6443 21.696 13.1904V9.42574C21.696 8.964 21.3482 8.61612 20.888 8.61612Z"
          fill="#FFDC00"
        />
        <path
          d="M30.1778 8.48181C28.6222 8.48181 27.3556 9.71942 27.3556 11.2413C27.3556 12.7632 28.6214 14.0008 30.1778 14.0008C31.7343 14.0008 33 12.7632 33 11.2413C33 9.71942 31.7343 8.48181 30.1778 8.48181ZM30.1778 12.4184C29.5136 12.4184 28.9731 11.8899 28.9731 11.2405C28.9731 10.5911 29.5136 10.0626 30.1778 10.0626C30.842 10.0626 31.3825 10.5911 31.3825 11.2405C31.3825 11.8899 30.842 12.4184 30.1778 12.4184Z"
          fill="#FFDC00"
        />
        <path
          d="M24.9406 14C23.3841 14 22.1184 12.7624 22.1184 11.2405C22.1184 9.71865 23.3841 8.48105 24.9406 8.48105C25.4795 8.48105 26.0039 8.63025 26.4577 8.91295C26.5886 8.99462 26.7139 9.08807 26.8296 9.19016C27.1613 9.48228 27.1878 9.98251 26.889 10.3068C26.5902 10.6311 26.0786 10.6571 25.7469 10.3649C25.6972 10.321 25.6441 10.2817 25.5879 10.2464C25.3952 10.1262 25.1719 10.0626 24.9414 10.0626C24.2772 10.0626 23.7367 10.5911 23.7367 11.2405C23.7367 11.89 24.2772 12.4185 24.9414 12.4185C25.1719 12.4185 25.3952 12.3548 25.5879 12.2347C25.6441 12.1994 25.698 12.1593 25.7469 12.1161C26.0786 11.824 26.5894 11.8491 26.889 12.1734C27.1886 12.4978 27.1621 12.9972 26.8304 13.2901C26.7155 13.3914 26.5902 13.4849 26.4585 13.5673C26.0039 13.8508 25.4795 14 24.9406 14Z"
          fill="#FFDC00"
        />
        <path
          fillRule="evenodd"
          d="M19.9475 9.29695C20.3692 8.6004 21.5779 7.54106 21.855 7.41306C22.0124 7.51593 22.1304 7.69576 22.1586 7.78685C22.1835 7.87794 22.2381 7.91564 22.2766 7.94155L22.0397 8.20069L22.1979 8.35539L22.2116 8.48339L22.4348 8.31691L22.7384 8.66401C21.908 9.32208 21.3972 10.0461 21.3056 10.2008L21.0165 9.92988L21.0816 9.84036L20.8976 9.62127L20.6471 9.95737L20.3571 9.69823L20.4752 9.53017L20.2905 9.64718L19.9475 9.29695Z"
          fill="#E20019"
        />
      </svg>
    </SvgIcon>
  );
};
export default MPBricoIcon;
